export default class AlertTimeOut {
    constructor() {
        this.init();
    }

    init() {
        const alertBoxes = document.querySelectorAll('.alert-time-out');

        alertBoxes.forEach(alertBox => {
            setTimeout(() => {
                alertBox.style.display = 'none';
            }, 5000);
        });
    }
}

